import React from 'react';
import { useSelector } from 'react-redux';
import { openInNewTab } from '../../../utils/utils';
import { finalRegistrationEnd } from '../../../ui/builders/utils';
import Button from './Button';
import iconsList from '../icons/iconsList';
import classes from './RegisterForFinal.module.css';

const RegisterForFinalButton = ({ bgcolor, text, icon, className, ...props }) => {

    const { texts } = useSelector((state) => state.translate);
    const { finalData, myFinalStatus } = useSelector((state) => state.contest);
    const state = useSelector((state) => state.contest);
    
    if (!finalData?.registrationLink || finalRegistrationEnd(state))    
          return null;  

    return (
        <div className={classes.registerForFinalButton}>
            {!myFinalStatus?.isSchoolRegisteredForFinal && <p className={classes.registerForFinalButtonText}>{texts.theRegistrationFinalOpenText}</p>}
            <Button
                onClick={() => openInNewTab(finalData?.registrationLink)}
                color={bgcolor || "#F2AD22"}
                text={text}
                iconName={icon || iconsList.registration}
                className={className}
                {...props}
            />
        </div>
    );
};

export default RegisterForFinalButton;

